import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { loginFormSchema } from './login-form.schema';

export const useLoginForm = () => {
  return useForm({
    resolver: yupResolver(loginFormSchema),
    defaultValues: {
      username: '',
      password: '',
      remember: false,
    },
  });
};
